.body {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  align-items: start;
}
.controls {
  min-width: 0;
  gap: 0.75rem;
}
[data-presentation="dialog"] .controls {
  max-height: min(65vh, 42rem);
  overflow-y: auto;
  overscroll-behavior: contain;
}
.category {
  min-width: 0;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  display: grid;
  gap: 0.75rem;
}
.instance {
  min-width: 0;
  padding-top: 0.75rem;
  border-top: 1px solid var(--color-border);
  display: grid;
  justify-items: start;
  gap: 0.5rem;
}
.viewer {
  gap: 0.75rem;
  padding: 1rem;
  --stage-min: 20rem;
}
@container (max-width: 640px) {
  .body { grid-template-columns: minmax(0, 1fr); }
  .viewer { order: -1; --stage-min: 12rem; }
  .controls { border-top: 1px solid var(--color-border); }
  [data-presentation="dialog"] .controls { max-height: 28rem; }
}
.qualifierPicker {
  width: 10rem;
  max-width: 100%;
  &[data-size="sm"] :global(.calmlens-select__control) {
    min-height: 2rem;
    font-size: 0.8125rem;
    padding-inline-start: 0.625rem;
    border-radius: 999px;
  }
}

.qualifierItem { max-width: 100%; }
.qualifierChip {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  border-radius: 999px;
  padding: 0.125rem 0.625rem;
  font-size: 0.8125rem;
  color: var(--color-foreground);
  border-color: var(--color-primary);
  background: var(--color-primary-soft);
}
.removeQualifier:global(.calmlens-button-button):global(.calmlens-button-size-sm) {
  width: 1.5rem;
  min-height: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.removeQualifier:global(.calmlens-button-button) svg {
  width: 0.75rem;
  height: 0.75rem;
  min-width: 0.75rem;
  min-height: 0.75rem;
}

.regionalAction {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 0;
}
@container (max-width: 640px) {
  .regionalAction {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    width: 100%;
    > :first-child, > :nth-child(2) { grid-column: 1; }
    > :last-child { grid-column: 2; grid-row: 1 / 3; }
  }
}

.decisionPreview {
  display: grid;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.instanceActions {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}
.actionPicker {
  width: 10.5rem;
}
